/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UnlinkIcon = /*#__PURE__*/ createSvgIcon(
  'UnlinkIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M12.73 10.583L11.374 9.25h.87c.213 0 .393.072.538.216A.723.723 0 0113 10a.66.66 0 01-.083.333.908.908 0 01-.209.25h.021zm3.812 7a.73.73 0 01-1.063 0L2.396 4.521a.73.73 0 010-1.063.729.729 0 011.062 0l13.084 13.084c.152.152.229.326.229.52a.718.718 0 01-.23.521zM6 14c-1.107 0-2.05-.39-2.83-1.17C2.39 12.05 2 11.107 2 10c0-.888.264-1.68.792-2.374.527-.695 1.277-1.244 2.25-1.647L6.5 7.5h-.48c-.707 0-1.305.243-1.79.73A2.41 2.41 0 003.5 10c0 .694.243 1.285.73 1.77.485.487 1.076.73 1.77.73h2.25c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 018.25 14H6zm1.748-3.25a.728.728 0 01-.53-.214.714.714 0 01-.218-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h.417l1.479 1.5H7.748zm7.44 2.333a.735.735 0 01-.115-.552.678.678 0 01.302-.469c.347-.236.621-.534.823-.895.201-.361.302-.75.302-1.167 0-.694-.243-1.285-.73-1.77A2.41 2.41 0 0014 7.5h-2.25a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 0111.75 6H14c1.107 0 2.05.39 2.83 1.17C17.61 7.95 18 8.893 18 10c0 .67-.16 1.296-.48 1.878a3.901 3.901 0 01-1.312 1.414.701.701 0 01-.552.104.715.715 0 01-.469-.313z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default UnlinkIcon;
